import { Serializable } from '../../../core/models/serializable';

export class CvDatabaseInvitesDetailModel
  implements Serializable<CvDatabaseInvitesDetailModel>
{
  fromObject(object: any): CvDatabaseInvitesDetailModel {
    Object.assign(this, object);
    this.details = {};
    this.totals = {};

    if (object && object.details) {
      Object.keys(object.details).forEach((k) => {
        let dict = object.details[k];
        if (dict) {
          this.details[k] = {};
          Object.keys(dict).forEach((k2) => {
            this.details[k][k2] = new InviteDetail().fromObject(dict[k2]);
          });
        }
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public details: { [date: string]: { [customer: string]: InviteDetail } };

  private totals: { [key: string]: number };

  public GetCustomerTotal(customer: string) {
    return this.GetCustomerStatusTotal(customer, 'total');
  }

  public GetCustomerStatusTotal(customer: string, field: string) {
    const key = customer + '|' + field;
    if (!(key in this.totals)) {
      this.totals[key] = Object.keys(this.details)
        .map((k) => this.details[k][customer])
        .reduce((a, b) => a + (b ? (b as any)[field] : 0), 0);
    }
    return this.totals[key];
  }
}

export class InviteDetail implements Serializable<InviteDetail> {
  fromObject(object: any): InviteDetail {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public customerId: number;
  public total: number;
  public notResponded: number;
  public interested: number;
  public interestedAndApplied: number;
  public notInterested: number;
}
